import React, { useState, useEffect, useContext } from 'react'

import ThemeSwitcher from 'react-css-vars'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { Button } from 'semantic-ui-react'

import { IProject, ITheme } from '../../../api/Data'
import Data from '../../../api/Data'
import { GlobalContext } from '../../../contexts/GlobalContext'
import { UserContext } from '../../../contexts/UserContext'

import SubSection from '../../../components/common/SubSection'
import Title from '../../../components/common/Title'

import CustomizeTabTemplateAdmin from './CustomizeTabTemplateAdmin'
import CustomizeVideoTemplatePage from './CustomizeVideoTemplatePage'

const CustomizeTab = (props: IProps) => {
  const { hasUserMadeChange, dispatchGlobalContext } = useContext(GlobalContext)
  const { userProfile } = useContext(UserContext)

  // Props
  const { projectTitle, history, location, match, project, theme, setTheme, setProject, exitProject } = props

  const { hasBrandedUploadPage } = userProfile.plan

  // States
  const [activeTab, setActiveTab] = useState<string>('Video Layout')

  // Url search query navigation
  useEffect(() => {
    if (location.search.startsWith('?tab=videoLayout')) setActiveTab('Video Layout')
    else if (location.search.startsWith('?tab=templateAdmin')) setActiveTab('Template Admin')
    else history.push(`/projects/${match.params.projectSlug}/customize?tab=videoLayout`)
  }, [history, location.search, match.params.projectSlug])
  
  const handleSubmitProject = async () => {
    dispatchGlobalContext({ type: 'set loading', payload: true })

    const { data, error } = await Data.updateProject(project)

    if (error) {
      dispatchGlobalContext({ type: 'set loading', payload: false })
      alert('Oops, something went wrong')
    }

    setTimeout(() => {
      setProject(data)
      dispatchGlobalContext({ type: 'set loading', payload: false })
    }, 1000)
  }

  // ------------------------------------------------Theme handles------------------------------------------------
  const handleChangeTheme = (newTheme: ITheme) => {
    dispatchGlobalContext({ type: 'set user has made changes', payload: true })

    setTheme(newTheme)
  }

  const handleSubmitTheme = async () => {
    dispatchGlobalContext({ type: 'set loading', payload: true })

    const { data, error } = await Data.updateTheme(theme)

    dispatchGlobalContext({ type: 'set user has made changes', payload: false })

    if (error) {
      dispatchGlobalContext({ type: 'set loading', payload: false })

      dispatchGlobalContext({ type: 'set user has made changes', payload: false })

      return alert(`An error occurred while updating your theme => ${error.response?.data}`)
    }

    setTheme(data)

    setTimeout(() => dispatchGlobalContext({ type: 'set loading', payload: false }), 1000)
  }
  
  const handleSave = () => {
    handleSubmitProject()
    handleSubmitTheme()
  }

  const { displaySetting } = project
  const { primaryFont, primaryColor, buttonTextColor } = displaySetting

  const uploadPageTheme = {
    primaryFont: hasBrandedUploadPage ? primaryFont : 'Roboto',
    primaryColor: hasBrandedUploadPage ? primaryColor : '#6b50ff',
    buttonTextColor: hasBrandedUploadPage ? buttonTextColor : '#FFFFFF',
  }
  console.log('Rendering Customize tab Container', activeTab)

  return (
    <ThemeSwitcher theme={uploadPageTheme}>
      {/* title */}
      <Title title={projectTitle}>
        <>
          <Button compact secondary disabled={!hasUserMadeChange} onClick={handleSave} style={{ border: '1px solid #fff' }}>
            Save
          </Button>
          <Button compact onClick={exitProject}>
            Close
          </Button>
        </>
      </Title>

      <SubSection hasGreyBackground>
        <>
          {activeTab === 'Video Layout' && (
            <CustomizeVideoTemplatePage theme={theme} handleChangeTheme={handleChangeTheme} />
          )}

          {activeTab === 'Template Admin' && (
            <CustomizeTabTemplateAdmin theme={theme} updateTheme={handleChangeTheme} />
          )}
        </>
      </SubSection>
    </ThemeSwitcher>
  )
}

interface IProps extends RouteComponentProps<any> {
  projectTitle: string
  project: IProject
  theme: ITheme
  setProject: (arg: IProject) => void
  setTheme: (arg: ITheme) => void
  exitProject: () => void
}

export default withRouter(CustomizeTab)
